import { useRef } from "react";
import { string, number } from "yup";
import { validationSchemas } from "constants/";
import { useFetchTenantUserFieldsQuery } from "queries/tenant.queries";
import {
  PlanPackageUserFieldDetails,
  TenantUserFieldDetails,
} from "features/types";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import dayjs from "dayjs";
const { birthdateValidation } = validationSchemas();
const validationPresets: { [key: string]: any } = {
  birthdate: birthdateValidation,
};

export const getFieldLabel = (
  field: TenantUserFieldDetails | PlanPackageUserFieldDetails
) => {
  return field.required
    ? field.field.displayName
    : field.field.displayName + " (optional)";
};

export const getFieldsValidation = (
  userFields:
    | Array<TenantUserFieldDetails | PlanPackageUserFieldDetails>
    | undefined
) => {
  if (!userFields) return {};
  return userFields.reduce((validation, tenantUserField) => {
    const {
      required,
      field: { type, name, displayName },
    } = tenantUserField;
    let userFieldValidation;

    if (validationPresets[name]) {
      userFieldValidation = validationPresets[name];
    } else {
      userFieldValidation =
        type === "NUMBER"
          ? number().label(displayName)
          : type === "DATE"
          ? string()
              .test(name, `${displayName} is not valid`, (value) => {
                if (value?.length === 0 || !value) return true;
                return (
                  /\d{2}\/\d{2}\/\d{4}/.test(value) && dayjs(value).isValid()
                );
              })
              .label(displayName)
          : string().label(displayName);
    }

    if (required) {
      userFieldValidation = userFieldValidation.required();
    }
    return {
      ...validation,
      [name]: userFieldValidation,
    };
  }, {});
};
export default function useTenantUserFields() {
  const fieldRefs = useRef<Array<any>>([]); // An array that contains all custom tenant's fields' ref
  const { data: tenantConfig } = useFetchTenantConfigurationQuery();

  const { data: tenantUserFields } = useFetchTenantUserFieldsQuery(
    tenantConfig?.id
  );

  const tenantFieldsValidation = getFieldsValidation(tenantUserFields);

  return {
    tenantUserFields,
    tenantFieldsValidation,
    fieldRefs,
  };
}
